import {
    REQUEST_UPDATE_ORDER, REQUEST_UPDATE_ORDER_FAILURE,
    REQUEST_UPDATE_ORDER_SUCCESS
} from "../../../constant/transaction/OrderConstant";


const initialState = {
    updateOrder: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const updateOrderReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_UPDATE_ORDER:
            return {
                ...state,
                updateOrder: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_UPDATE_ORDER_SUCCESS:
            return {
                ...state,
                updateOrder: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_UPDATE_ORDER_FAILURE:
            return {
                ...state,
                updateOrder: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
